import React, { useState, useMemo, useCallback } from "react";
import { Formik, Form } from "formik";
import { useSelector, useDispatch } from "react-redux";
import Card from "components/Layout/Card";
import Button from "components/form/Button";
import AddOnsDetails from "../AIAbstractSubmission/StepComponents/AddOnsDetails";
import { icons } from "utils/constants";
import {
    handleRemoveAddOnService,
    handleUpdateAddOnService,
    setPaperData,
    showSuccess,
    throwError,
} from "store/slices";
import { formattedDateTime, objectToFormData } from "utils/helpers";

const UserAddOnServices = () => {
    const dispatch = useDispatch();
    const { paperData } = useSelector((state) => state.global) || {};
    console.log('✌️paperData --->', paperData);

    const [addOnServicesView, setAddOnServicesView] = useState(false);
    const [btnLoading, setBtnLoading] = useState(false);
    const [deletingId, setDeletingId] = useState(null);

    const initialValues = useMemo(
        () => ({
            add_on_services: paperData?.add_on_services || [],
        }),
        [paperData]
    );

    const checkedServices =
        paperData?.add_on_services?.filter((s) => s.isChecked) || [];

    const showNoData =
        !paperData?.add_on_services?.length || checkedServices.length === 0;


    const handleAddOnServicesSubmit = async (values) => {
        try {
            setBtnLoading(true);
            const payload = {
                abstract_id: paperData?.id,
                add_on_services: JSON.stringify(values?.add_on_services),
            };

            const response = await dispatch(
                handleUpdateAddOnService(objectToFormData(payload))
            );

            if (response?.data) {
                dispatch(showSuccess(response?.message || "Add-on services updated successfully!"));
                dispatch(setPaperData({ ...paperData, add_on_services: response?.data }))
                setAddOnServicesView(false);
            }
        } catch (err) {
            dispatch(throwError(err));
        } finally {
            setBtnLoading(false);
        }
    };

    const handleRemove = async (id) => {
        try {
            setDeletingId(id);
            const response = await dispatch(handleRemoveAddOnService(id));
            if (response?.data) {
                dispatch(showSuccess("Service removed successfully"));
                dispatch(setPaperData({ ...paperData, add_on_services: response?.data }))
            }
        } catch (err) {
            dispatch(throwError(err));
        } finally {
            setDeletingId(null);
        }
    };

    if (!addOnServicesView && showNoData) {
        return (
            <Card className="cmt-10 cps-25 cpt-16 cpb-32 cpe-25">
                <div className="d-flex flex-column justify-content-center align-items-center cpb-125">
                    <img
                        src={icons.circleInfo}
                        alt="No Data"
                        height={40}
                        width={40}
                        className="cmt-56"
                    />
                    <h3 className="cmt-22 text-24-500-30 color-dark-gray">
                        Add-On Services Not Found
                    </h3>
                    <div className="cmt-22 d-flex justify-content-center">
                        <Button
                            text="+ Add-On Services"
                            btnStyle="primary-outline"
                            className="h-35 text-14-500 w-auto px-3"
                            onClick={() => setAddOnServicesView(true)}
                            disabled={btnLoading}
                        />
                    </div>
                </div>
            </Card>
        );
    }

    if (addOnServicesView) {
        return (
            <Card>
                <Formik
                    initialValues={initialValues}
                    enableReinitialize
                    onSubmit={handleAddOnServicesSubmit}
                >
                    {(formikProps) => (
                        <Form>
                            <AddOnsDetails
                                {...formikProps}
                                onNext={formikProps.handleSubmit}
                                onBack={() => setAddOnServicesView(false)}
                                btnLoading={btnLoading}
                            />
                        </Form>
                    )}
                </Formik>
            </Card>
        );
    }

    return (
        <Card className="cmt-10 cps-25 cpt-16 cpb-32 cpe-25">
            <div className="d-flex justify-content-between align-items-center cmb-14">
                <div className="text-16-400-20 color-1717">Selected Add-ons</div>
                <Button
                    text="+ Add-On Services"
                    btnStyle="primary-outline"
                    className="h-35 text-14-500 w-auto px-3 cmb-11"
                    onClick={() => setAddOnServicesView(true)}
                    disabled={btnLoading}
                />
            </div>

            <div className="border-bottom cmb-18 color-d1d1"></div>

            <div className="row">
                {checkedServices?.map((service) => (
                    <div key={service.id} className="col-6 cmb-20">
                        <div
                            className="cp-24 br-5 b-d1d1 hover:shadow-lg transition-shadow duration-300"
                            style={{ minHeight: "200px" }}
                        >
                            <div className="d-flex justify-content-between align-items-center mb-2">
                                <h3 className="color-dark-gray text-16-500-20">
                                    {service?.service_name}
                                </h3>
                                <div
                                    className="pointer"
                                    onClick={() => handleRemove(service?.id)}
                                >
                                    {deletingId === service?.id ? (
                                        <i className="bi bi-hourglass-split"></i>
                                    ) : (
                                        <i className="bi bi-trash"></i>
                                    )}
                                </div>
                            </div>
                            <p className="text-14-300-24">
                                {service?.service_description}
                            </p>
                            <span className="text-14-400-18 color-6866 mt-auto">
                                {formattedDateTime(service?.updated_at)}
                            </span>
                        </div>
                    </div>
                ))}
            </div>
        </Card>
    );
};

export default UserAddOnServices;
